import { FormattedNumber } from 'react-intl';
import { useSelector } from '@algoan/dashboard/store/store';
import { currencySelector } from '@algoan/dashboard/store/selectors';

export const FormattedMoney: React.FC<{ number: number }> = ({ number }) => {
  const currency = useSelector(currencySelector);

  return <FormattedNumber value={number} style="currency" currency={currency === 'GBP' ? 'GBP' : 'EUR'} />;
};
